<h3>Upgrade to apply Pro optimization</h3>
<p class="mt5 db-desc">
  Pro optimization level is available with all Pro plans<br/> of 10Web Booster.
</p>
<div class="db-upgrade-features mt30 pl10">
  <div *ngFor="let feature of features"><i class="db-icon db-icon-ds-diamond mr8"></i><span>{{feature}}</span>
  </div>
</div>

<div class="db-upgrade-extra-features mt33">
  <div class="db-label"><span>Powered by Cloudflare CDN</span></div>
  <div *ngFor="let feature of extraFeatures">
   <i class="db-icon db-icon-ds-dot mr8"></i> <span>{{feature}}</span>
  </div>
</div>

<div class="db-upgrade-button">
<button class="ds-btn-green ds-btn-xl mt30" (click)="redirectToUpgradePage()">
  <span>Upgrade</span>
</button>
</div>
<p class="db-money-back mt15">
  Cancel Anytime
</p>
